/* Houndstooth brand behaviors: order-deadline countdown + sticky add-to-cart.
   Only runs on templates with body[data-brand="greek"|"custom"]. */
(function () {
  var brand = document.body && document.body.dataset ? document.body.dataset.brand : '';
  if (brand !== 'greek' && brand !== 'custom') return;

  document.querySelectorAll('[data-bcountdown]').forEach(initCountdown);

  var sticky = document.querySelector('[data-bsticky]');
  if (sticky) {
    try {
      initSticky(sticky);
    } catch (e) {
      /* Non-fatal: the native product form still works. */
    }
  }

  /* ---------------- Countdown ---------------- */
  function initCountdown(el) {
    var target = parseInt(el.getAttribute('data-deadline'), 10);
    if (!target) return;
    target = target * 1000;
    var openView = el.querySelector('[data-bcountdown-open]');
    var closedView = el.querySelector('[data-bcountdown-closed]');
    var dEl = el.querySelector('[data-cd-d]');
    var hEl = el.querySelector('[data-cd-h]');
    var mEl = el.querySelector('[data-cd-m]');
    var sEl = el.querySelector('[data-cd-s]');

    function pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        if (openView) openView.hidden = true;
        if (closedView) closedView.hidden = false;
        clearInterval(iv);
        return;
      }
      var total = Math.floor(diff / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      if (dEl) dEl.textContent = d;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    var iv = setInterval(tick, 1000);
  }

  /* ---------------- Sticky add-to-cart ---------------- */
  function initSticky(sticky) {
    /* The main product wrapper is <product-info id="MainProduct-{{ section.id }}">;
       section.id is the long template form (template--…__main), never the bare
       template key, so match by prefix on any element. */
    var sectionId = sticky.getAttribute('data-section-id');
    var productRoot = document.querySelector('[id^="MainProduct-"]');
    if (!productRoot && sectionId) productRoot = document.getElementById('MainProduct-' + sectionId);
    if (!productRoot) return;

    var bar = sticky.querySelector('[data-bsticky-bar]');
    var barBtn = sticky.querySelector('[data-bsticky-btn]');
    var barVariant = sticky.querySelector('[data-bsticky-variant]');
    var sheet = sticky.querySelector('[data-bsheet]');
    var pillsBox = sticky.querySelector('[data-bsheet-pills]');
    var sheetCta = sticky.querySelector('[data-bsheet-cta]');

    /* ---- Stay on the product page after adding ----
       Redirecting to /cart kills the chance of a second item. Instead we
       confirm inline: the sheet swaps to a confirmation view, the native
       button shows a toast. Both offer "View cart" without forcing it. */
    function refreshCartCount() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var link = document.querySelector('.bheader__cart');
          if (!link) return;
          var badge = link.querySelector('.bheader__count');
          if (cart.item_count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'bheader__count';
              link.appendChild(badge);
            }
            badge.textContent = cart.item_count;
          } else if (badge) {
            badge.parentNode.removeChild(badge);
          }
          link.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
        })
        .catch(function () { /* count is decorative; never block */ });
    }

    var sheetPanel = sheet.querySelector('.bsheet__panel');
    var doneView = document.createElement('div');
    doneView.className = 'bsheet__done';
    doneView.hidden = true;
    doneView.innerHTML =
      '<div class="bsheet__done-icon" aria-hidden="true">&#10003;</div>' +
      '<div class="bsheet__done-title">Added to cart</div>' +
      '<div class="bsheet__done-variant" data-bsheet-done-variant></div>' +
      '<div class="bsheet__done-actions">' +
        '<button type="button" class="bsheet__done-keep" data-bsheet-done-keep>Keep shopping</button>' +
        '<a class="bsheet__done-cart" href="/cart">View cart</a>' +
      '</div>';
    if (sheetPanel) sheetPanel.appendChild(doneView);
    var doneVariant = doneView.querySelector('[data-bsheet-done-variant]');
    var doneKeep = doneView.querySelector('[data-bsheet-done-keep]');

    function showSheetDone() {
      if (doneVariant) {
        doneVariant.textContent = state.title + (state.price != null ? ' — ' + money(state.price) : '');
      }
      sheet.classList.add('is-done');
      doneView.hidden = false;
    }
    function hideSheetDone() {
      sheet.classList.remove('is-done');
      doneView.hidden = true;
    }
    if (doneKeep) doneKeep.addEventListener('click', closeSheet);

    var toast = null;
    var toastTimer = null;
    function showToast() {
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'btoast';
        toast.setAttribute('role', 'status');
        var msg = document.createElement('span');
        msg.className = 'btoast__msg';
        var link = document.createElement('a');
        link.className = 'btoast__link';
        link.href = '/cart';
        link.textContent = 'View cart';
        toast.appendChild(msg);
        toast.appendChild(link);
        document.body.appendChild(toast);
      }
      toast.querySelector('.btoast__msg').textContent =
        'Added to cart' + (state.title ? ' — ' + state.title : '');
      toast.classList.add('is-visible');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 4500);
    }

    /* ---- Variant state ----
       This Dawn version rebuilds the <variant-selects> element via AJAX on
       every option change (product-info.js updateOptionValues) and ignores
       option selections made outside <product-info> (contains() gate). So the
       sheet renders its own pills that proxy clicks to the live picker, and
       labels track Dawn's own pub/sub plus the picker's [data-selected-variant]
       JSON. Nothing here depends on nodes Dawn may replace. */
    var state = { id: null, price: null, available: true, title: '', options: [] };
    var optionOrder = [];

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function livePicker() {
      return productRoot.querySelector('variant-selects');
    }
    function readSelectedVariant() {
      /* The replacement <variant-selects> always carries fresh JSON for the
         current selection in [data-selected-variant]. */
      var picker = livePicker();
      var s = picker && picker.querySelector('script[data-selected-variant]');
      if (!s) return null;
      try {
        return JSON.parse(s.textContent);
      } catch (e) {
        return null;
      }
    }
    function applyVariant(v) {
      if (!v) {
        state.id = null;
        state.price = null;
        state.available = false;
        state.title = '';
        state.options = [];
      } else {
        state.id = String(v.id);
        if (typeof v.price === 'number') state.price = v.price;
        state.available = v.available !== false;
        state.title = v.title || '';
        state.options = [v.option1, v.option2, v.option3];
      }
      refreshLabels();
      syncPills();
    }
    function refreshFromLivePicker() {
      var v = readSelectedVariant();
      if (v) applyVariant(v);
    }

    function refreshLabels() {
      var label = state.price != null ? 'Add to cart — ' + money(state.price) : 'Add to cart';
      if (barBtn) barBtn.textContent = label;
      if (sheetCta) sheetCta.textContent = label;
      if (barVariant) barVariant.textContent = state.title || '';
      var ok = !!state.id && state.available !== false;
      if (sheetCta) sheetCta.disabled = !ok;
    }

    /* ---- Sheet pills: our own UI, proxying clicks to Dawn's live picker ---- */
    function collectOptionGroups() {
      var groups = [];
      var seen = {};
      var picker = livePicker();
      if (!picker) return groups;
      var inputs = picker.querySelectorAll('input[data-option-name]');
      for (var i = 0; i < inputs.length; i++) {
        var n = inputs[i].getAttribute('data-option-name');
        if (!seen[n]) {
          seen[n] = [];
          groups.push({ name: n, values: seen[n] });
        }
        if (seen[n].indexOf(inputs[i].value) === -1) seen[n].push(inputs[i].value);
      }
      return groups;
    }
    function liveInputFor(optionName, value) {
      var picker = livePicker();
      if (!picker) return null;
      var inputs = picker.querySelectorAll('input[data-option-name]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].getAttribute('data-option-name') === optionName && inputs[i].value === value) {
          return inputs[i];
        }
      }
      return null;
    }
    function proxySelect(optionName, value) {
      /* Drive Dawn exactly as a shopper click would: toggle the real input so
         its change pipeline (price, URL, availability, hidden id, pub/sub)
         runs natively. The picker is re-queried every time because Dawn
         replaces the element on each selection. */
      var inp = liveInputFor(optionName, value);
      if (!inp || inp.disabled) return;
      if (!inp.checked) inp.click();
    }
    function buildPills() {
      if (!pillsBox) return;
      var groups = collectOptionGroups();
      optionOrder = groups.map(function (g) { return g.name; });
      pillsBox.innerHTML = '';
      groups.forEach(function (g) {
        var wrap = document.createElement('div');
        wrap.className = 'bsheet-opt';
        var lab = document.createElement('div');
        lab.className = 'bsheet-opt__label';
        lab.textContent = g.name + ': ';
        var cur = document.createElement('strong');
        cur.setAttribute('data-opt-current', g.name);
        lab.appendChild(cur);
        wrap.appendChild(lab);
        var row = document.createElement('div');
        row.className = 'bsheet-opt__pills';
        g.values.forEach(function (val) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'bsheet-pill';
          b.setAttribute('data-opt-name', g.name);
          b.setAttribute('data-opt-val', val);
          b.setAttribute('aria-pressed', 'false');
          b.textContent = val;
          b.addEventListener('click', function () { proxySelect(g.name, val); });
          row.appendChild(b);
        });
        wrap.appendChild(row);
        pillsBox.appendChild(wrap);
      });
      syncPills();
    }
    function syncPills() {
      if (!pillsBox) return;
      var btns = pillsBox.querySelectorAll('[data-opt-name]');
      for (var i = 0; i < btns.length; i++) {
        (function (btn) {
          var name = btn.getAttribute('data-opt-name');
          var val = btn.getAttribute('data-opt-val');
          var idx = optionOrder.indexOf(name);
          var cur = idx > -1 ? state.options[idx] : undefined;
          var selected = cur !== undefined && cur === val;
          btn.classList.toggle('is-selected', !!selected);
          btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
          var live = liveInputFor(name, val);
          if (live) {
            btn.disabled = live.disabled;
            btn.classList.toggle('is-disabled', live.disabled);
          }
        })(btns[i]);
      }
      var curs = pillsBox.querySelectorAll('[data-opt-current]');
      for (var j = 0; j < curs.length; j++) {
        var idx2 = optionOrder.indexOf(curs[j].getAttribute('data-opt-current'));
        curs[j].textContent = idx2 > -1 && state.options[idx2] ? state.options[idx2] : '';
      }
    }

    /* ---- Bar visibility ----
       Show the bar once the native buy button is genuinely off-screen.
       The buy button is re-queried on each check because Dawn may swap
       nearby DOM on variant changes; getBoundingClientRect on scroll is used
       (not IntersectionObserver) because Dawn's desktop info column is
       position:sticky, which keeps the form intersecting the viewport. */
    var ticking = false;
    function updateBar() {
      ticking = false;
      if (!bar) return;
      if (sheet.classList.contains('is-open')) {
        bar.classList.remove('is-visible');
        return;
      }
      var buyBtn = productRoot.querySelector('.product-form__submit') || productRoot.querySelector('product-form');
      if (!buyBtn || !buyBtn.getBoundingClientRect) return;
      var r = buyBtn.getBoundingClientRect();
      var outOfView = r.bottom < 0 || r.top > window.innerHeight;
      bar.classList.toggle('is-visible', outOfView);
    }
    function requestBarUpdate() {
      if (!ticking) {
        ticking = true;
        (window.requestAnimationFrame || function (fn) { setTimeout(fn, 16); })(updateBar);
      }
    }
    window.addEventListener('scroll', requestBarUpdate, { passive: true });
    window.addEventListener('resize', requestBarUpdate);

    function openSheet() {
      if (pillsBox && !pillsBox.hasChildNodes()) buildPills();
      refreshFromLivePicker();
      sheet.classList.add('is-open');
      bar.classList.remove('is-visible');
      document.body.style.overflow = 'hidden';
      var closeBtn = sheet.querySelector('[data-bsheet-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeSheet() {
      hideSheetDone();
      sheet.classList.remove('is-open');
      document.body.style.overflow = '';
      refreshLabels();
      updateBar();
    }

    sheet.querySelectorAll('[data-bsheet-close]').forEach(function (el) {
      el.addEventListener('click', closeSheet);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
    });

    function setBusy(busy) {
      [barBtn, sheetCta].forEach(function (b) {
        if (b) b.disabled = busy;
      });
    }
    function currentHiddenId() {
      var inp = productRoot.querySelector('product-form input[name="id"]');
      return inp && inp.value ? inp.value : null;
    }
    function currentQty() {
      var q = productRoot.querySelector('input[name="quantity"]');
      return q && q.value ? q.value : 1;
    }

    function addToCart() {
      var id = state.id || currentHiddenId();
      if (!id) {
        openSheet();
        return;
      }
      setBusy(true);
      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', currentQty());
      fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          setBusy(false);
          refreshCartCount();
          showSheetDone();
        })
        .catch(function () {
          /* Fallback: close the sheet and let the shopper use the native form. */
          setBusy(false);
          refreshLabels();
          closeSheet();
          var native = productRoot.querySelector('product-form');
          if (native) native.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }

    /* Bar opens the sheet for review; the sheet CTA adds. */
    if (barBtn) barBtn.addEventListener('click', openSheet);
    if (sheetCta) sheetCta.addEventListener('click', addToCart);

    /* ---- Track Dawn's variant changes ----
       Primary: Dawn's own pub/sub 'variant-change' (fired after its DOM
       updates settle). Backup: the bubbling change Dawn dispatches on the
       hidden id input. Both funnel into a re-read of the live picker's
       [data-selected-variant] JSON, so labels never depend on replaced nodes. */
    if (typeof window.subscribe === 'function') {
      try {
        window.subscribe('variant-change', function (evt) {
          var d = evt && evt.data;
          if (!d) return;
          if (d.sectionId != null && productRoot.dataset) {
            var sid = String(d.sectionId);
            var mine = [String(productRoot.dataset.section || ''), String(productRoot.dataset.originalSection || '')];
            if (mine.indexOf(sid) === -1) return;
          }
          if (d.variant) applyVariant(d.variant);
          else refreshFromLivePicker();
        });
      } catch (e) { /* backup listener below still covers us */ }
    }
    productRoot.addEventListener('change', function (e) {
      if (e && e.target && e.target.name === 'id') {
        setTimeout(refreshFromLivePicker, 0);
      }
    });

    /* Deterministic native buy buttons: AJAX-add, then confirm on the page
       (the theme's cart drawer lives in the hidden header group, so the
       native handler's drawer flow would appear broken). */
    productRoot.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || form.tagName !== 'FORM' || !form.closest('product-form')) return;
        var id = state.id || currentHiddenId();
        if (!id) return; /* let Dawn show its own select-options messaging */
        e.preventDefault();
        e.stopPropagation();
        setBusy(true);
        var fd = new FormData();
        fd.append('id', id);
        fd.append('quantity', currentQty());
        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin'
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () {
            setBusy(false);
            refreshCartCount();
            showToast();
            refreshLabels();
          })
          .catch(function () {
            /* Fallback: plain POST, which Shopify redirects to /cart. */
            setBusy(false);
            refreshLabels();
            form.submit();
          });
      },
      true
    );

    buildPills();
    refreshFromLivePicker();
    updateBar();
  }

})();
